import { render, staticRenderFns } from "./smtpModal.vue?vue&type=template&id=4deed730&scoped=true&"
import script from "./smtpModal.vue?vue&type=script&lang=js&"
export * from "./smtpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deed730",
  null
  
)

export default component.exports